// TanStack Query keys and hooks for the Answer library.
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { answersApi } from "./answersApi";

export const answersKeys = {
  all: ["answers"] as const,
  list: (q: string) => ["answers", q.trim().toLowerCase()] as const,
};

export function useAnswers(q: string) {
  return useQuery({
    queryKey: answersKeys.list(q),
    queryFn: ({ signal }) => answersApi.list(q, signal),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
